import React from 'react';
import AppTabs from '@/components/AppTabs';
import { Outlet } from 'react-router';
import RoutesProvider from '@/context/routes/context';
import { RequireAuth } from '@/App';
import LearningContentsProvider from '@/context/contents/context';
import StagesProvider from '@/context/stages/context';
import theme from '@/constants/theme';

const MainLayout = () => {
  return (
    <RequireAuth>
      <RoutesProvider>
        <StagesProvider>
          <LearningContentsProvider>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '100dvh',
                position: 'relative',
                maxWidth: theme.appWidth,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                flex: 1,
              }}
            >
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
                <Outlet />
              </div>
              <AppTabs />
            </div>
          </LearningContentsProvider>
        </StagesProvider>
      </RoutesProvider>
    </RequireAuth>
  );
};

export default MainLayout;
